import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, RadioGroup, FormControlLabel,
  Radio, Typography, Box, CircularProgress, Alert
} from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';

/**
 * Modal component for therapists to manually initiate assessments for clients
 */
const ManualAssessmentModal = ({
  isOpen,
  onClose,
  assessments,
  selectedKey,
  onKeyChange,
  onSubmit,
  loading,
  error,
  clientName
}) => {
  const title = `Initiate Assessment for ${clientName || 'Client'}`;
  
  return (
    <Dialog open={isOpen} onClose={loading ? null : onClose} maxWidth="sm" fullWidth data-testid="assessment-modal">
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <AssessmentIcon sx={{ mr: 1 }} />
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        
        <Typography variant="body2" paragraph sx={{ mt: 1 }}>
          Select an assessment to send to the client:
        </Typography>
        
        <FormControl component="fieldset" fullWidth>
          <RadioGroup value={selectedKey} onChange={(e) => onKeyChange(e.target.value)}>
            {(assessments || []).map(assessment => (
              <Box key={assessment.testKey} sx={{ mb: 2, p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <FormControlLabel
                  value={assessment.testKey}
                  control={<Radio />}
                  label={<Typography variant="subtitle2">{assessment.fullName}</Typography>}
                />
                {assessment.description && (
                  <Typography variant="body2" sx={{ ml: 4, mt: 0.5, color: 'text.secondary' }}>
                    {assessment.description}
                  </Typography>
                )}
              </Box>
            ))}
          </RadioGroup>
        </FormControl>
        
        {assessments.length === 0 && !loading && (
          <Typography color="error">No assessments available.</Typography>
        )}
        
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          disabled={loading || !selectedKey}
          color="primary"
        >
          Initiate Assessment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManualAssessmentModal;
